/**
 * Bursa: sertarul și pagina de coș din prototip.
 * - deschide sertarul când tema adaugă ceva în coș (evenimentul shopify:cart:lines-update)
 * - butoanele +/− și „Elimină” schimbă câte un bax (cantitatea din Shopify e în pachete)
 * - după fiecare schimbare, secțiunile de coș se reîncarcă prin Section Rendering API
 */
(function () {
  if (window.__bdsCart) return;
  window.__bdsCart = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = function () { return document.querySelector('[data-bds-drawer]'); };
  var overlay = function () { return document.querySelector('[data-bds-drawer-overlay]'); };

  function sectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('[data-bds-cart-section]'), function (el) {
      return el.dataset.bdsCartSection;
    });
  }

  function paint(sections) {
    Object.keys(sections || {}).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-bds-cart-section="' + id + '"]');
      var current = document.querySelector('[data-bds-cart-section="' + id + '"]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    });
    var cart = document.querySelector('[data-bds-cart]');
    if (cart) {
      document.querySelectorAll('[data-bds-cart-count]').forEach(function (el) {
        el.textContent = cart.dataset.baxCount;
      });
    }
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(root + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint);
  }

  function change(line, quantity) {
    var box = document.querySelectorAll('[data-bds-cart]');
    box.forEach(function (b) { b.classList.add('is-busy'); });
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds() })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections) paint(res.sections);
        else return refresh();
      })
      .catch(refresh);
  }

  function open() {
    var d = drawer();
    if (!d) { window.location.href = root + 'cart'; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    overlay().classList.add('is-open');
    document.documentElement.classList.add('bds-no-scroll');
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    overlay().classList.remove('is-open');
    document.documentElement.classList.remove('bds-no-scroll');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bds-cart-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-bds-drawer-close]') || e.target.matches('[data-bds-drawer-overlay]')) {
      close();
      return;
    }
    var lineEl = e.target.closest('.bds-cart-line');
    if (!lineEl) return;
    var line = +lineEl.dataset.line;
    var packs = +lineEl.dataset.packs || 1;
    var qty = +lineEl.dataset.qty;
    var step = e.target.closest('[data-bds-step]');
    if (step) {
      var baxes = Math.floor(qty / packs) + +step.dataset.bdsStep;
      change(line, Math.max(0, baxes * packs));
    } else if (e.target.closest('[data-bds-remove]')) {
      change(line, 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-bds-line-q]')) return;
    var lineEl = e.target.closest('.bds-cart-line');
    var packs = +lineEl.dataset.packs || 1;
    var baxes = Math.max(0, parseInt(e.target.value, 10) || 0);
    change(+lineEl.dataset.line, baxes * packs);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Tema emite acest eveniment la „Adaugă în coș”; promisiunea se rezolvă după ce coșul s-a actualizat.
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = (e.detail && e.detail.promise) || e.promise || Promise.resolve();
    Promise.resolve(p)
      .catch(function () {})
      .then(function () { return new Promise(function (r) { setTimeout(r, 150); }); })
      .then(refresh)
      .then(function () {
        if (document.querySelector('[data-bds-drawer]') && !document.querySelector('.bds-main-cart-section')) open();
      });
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();
